import React, { useState } from 'react'
import ProductGrid from 'src/components/ProductGrid'
import {
  Header,
  Headline,
  ProductsWrapper,
  Filters,
  SortContainer,
  TotalProducts,
  TopContainer,
  ActiveFilters,
  InnerContainer,
  StTabletFilterButton,
  ActiveFiltersTablet,
  StFilterAmount,
} from './styles'
import { useTranslation } from 'react-i18next'
import { FilterTagList } from 'src/components/FilterTags/FilterTagList'
import { FilterSideBarMobile } from 'src/components/FilterSideBarMobile'

export const ProductGridWrapper = ({
  headline,
  totalCount,
  styleFilter,
  sizeFilter,
  colorFilter,
  promotionsFilter,
  sortDropdown,
  sorting,
  products,
  collectionFilter,
  isSearch = false,
  allFilterValues = [''],
  removeFilterValue = () => {},
  clearAllFilters = () => {},
  selectedFilterCount,
  colorFilterListMobile,
  sizeFilterListMobile,
  styleFilterList,
  collectionFilterList,
  promotionsFilterList,
  hideFilters,
}) => {
  const { t } = useTranslation('misc')
  const [itemCount, setItemCount] = useState(0)
  const [showFilters, setShowFilters] = useState(false)

  const productsTotal = () => {
    if (!isSearch) {
      if (itemCount === products.length) {
        if (itemCount === 1) {
          return (
            <>
              ({itemCount}&nbsp;{t('product')})
            </>
          )
        } else {
          return (
            <>
              ({itemCount}&nbsp;{t('products')})
            </>
          )
        }
      } else {
        return (
          <>
            ({itemCount} of {products.length}&nbsp;{t('products')})
          </>
        )
      }
    }
    return null
  }

  const activeFilter = hideFilters ? (
    <div />
  ) : (
    <ActiveFilters>
      {selectedFilterCount !== undefined ? (
        <button
          onClick={() => setShowFilters(true)}
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            margin: '0 0 1.3em 0',
            padding: '0',
            cursor: 'pointer',
            backgroundColor: 'transparent',
            border: '0',
          }}
        >
          <span
            style={{
              fontSize: '14px',
            }}
          >
            Filter
          </span>
          {selectedFilterCount > 0 && (
            <StFilterAmount style={{ marginLeft: '0.5em' }}>{selectedFilterCount}</StFilterAmount>
          )}
        </button>
      ) : null}
    </ActiveFilters>
  )
  const activeFilterTablet = hideFilters ? (
    <div />
  ) : (
    <ActiveFiltersTablet>
      {selectedFilterCount !== undefined ? (
        <button
          onClick={() => setShowFilters(true)}
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            margin: '0 0 1.3em 0',
            padding: '0',
            backgroundColor: 'transparent',
            border: '0',
          }}
        >
          <span
            style={{
              fontSize: '14px',
            }}
          >
            Filter
          </span>
          {selectedFilterCount > 0 && (
            <StFilterAmount style={{ marginLeft: '0.5em', marginTop: '.25em' }}>
              {selectedFilterCount}
            </StFilterAmount>
          )}
        </button>
      ) : null}
    </ActiveFiltersTablet>
  )

  return (
    <ProductsWrapper isFixed={showFilters}>
      {hideFilters ? null : (
        <FilterSideBarMobile
          itemCount={itemCount}
          isOpen={showFilters}
          setIsOpen={setShowFilters}
          colorFilterList={colorFilterListMobile}
          sizeFilterList={sizeFilterListMobile}
          typeFilterList={styleFilterList}
          collectionFilterList={collectionFilterList}
          promotionsFilterList={promotionsFilterList}
          selectedFilterCount={selectedFilterCount}
          allFilterValues={allFilterValues}
          removeFilterValue={removeFilterValue}
          clearAllFilters={clearAllFilters}
        />
      )}
      <Header>
        <Headline>
          {headline}&nbsp;
          <TotalProducts>{productsTotal()}</TotalProducts>
        </Headline>
        {totalCount > 0 && (
          <TopContainer>
            {activeFilter}
            <InnerContainer>
              <SortContainer>
                <Filters>{sortDropdown}</Filters>
              </SortContainer>
            </InnerContainer>
          </TopContainer>
        )}
      </Header>
      <div style={{ position: 'relative' }}>
        <StTabletFilterButton>{activeFilterTablet}</StTabletFilterButton>
        <FilterTagList
          onRemove={removeFilterValue}
          filterValues={allFilterValues}
          clearAll={clearAllFilters}
        />
      </div>
      <ProductGrid
        setItemCount={setItemCount}
        promotionsFilter={promotionsFilter}
        collectionFilter={collectionFilter}
        styleFilter={styleFilter}
        colorFilter={colorFilter}
        sizeFilter={sizeFilter}
        sorting={sorting}
        products={products}
      />
    </ProductsWrapper>
  )
}
